import { useDevice } from '@/hooks/shared/use-device';
import * as React from 'react';

export function useBankIDUrl() {
  const device = useDevice();

  return React.useCallback(
    (autoStartToken: string, transactionId: string): string => {
      let callbackUrl: string;

      if (device.isChromeOnAppleDevice) {
        callbackUrl = encodeURIComponent('googlechrome://');
      } else if (device.isFirefoxOnAppleDevice) {
        callbackUrl = encodeURIComponent('firefox://');
      } else if (device.isOperaTouchOnAppleDevice) {
        callbackUrl = encodeURIComponent(
          `${window.location.href.replace('http', 'touch-http')}?transactionId=${transactionId}`,
        );
      } else {
        callbackUrl = encodeURIComponent(`${window.location.href}?transactionId=${transactionId}`);
      }

      return device.isMobileOrTablet
        ? `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=${callbackUrl}`
        : `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
    },
    [device],
  );
}
